import { configureStore } from "@reduxjs/toolkit";
import dialogSlice from "../components/dialog/dialogSlice";
import userSlice from "../features/user/userSlice";
import drawerSlice from "../components/drawer/drawerSlice";
import menuSlice from "../features/menu/menuSlice";
import userTypeSlice from "../features/userType/userTypeSlice";
import inquirySlice from "../features/inquiry/inquirySlice";
import cmsSlice from "../features/cms/cmsSlice";
import seotagSlice from "../features/seotag/seotagSlice";
import testimonialSlice from "../features/testimonial/testimonialSlice";
import blogSlice from "../features/blog/blogSlice";
import faqSlice from "../features/faq/faqSlice";
import bannerSlice from "../features/banner/bannerSlice";
import rightsSlice from "../features/rights/rightsSlice";
import loginSlice from "../features/login/loginSlice";
import paginationSlice from "../features/pagination/paginationSlice";
import settingSlice from "../features/setting/settingSlice";
import facilitySlice from "../features/facility/facilitySlice";
import whychooseSlice from "../features/whychoose/whychooseSlice";
import amenitiesSlice from "../features/amenities/amenitiesSlice";
import tourtypeSlice from "../features/tourtype/tourtypeSlice";
import activitySlice from "../features/activities/activitiesSlice";
import gallerySlice from "../features/gallery/gallerySlice";
import roomSlice from "../features/room/roomSlice";
import signatureMomentSlice from "../features/signaturemoment/signatureMomentSlice";
import propertySlice from "../features/property/propertySlice";
import experienceSlice from "../features/experience/experienceSlice";
import philosophySlice from "../features/philosophy/philosophySlice";
import weddingVenueSlice from "../features/weddingvenue/weddingVenueSlice";
import idealSlice from "../features/ideal/idealSlice";
import attractionsSlice from "../features/attraction/attractionsSlice";
import newsletterSlice from "../features/newsletter/newsletterSlice";
import packageSlice from "../features/package/packageSlice";
import positionSlice from "../features/position/positionSlice";
import jobapplicationSlice from "../features/jobapplication/jobapplicationSlice";
import videoGallerySlice from "../features/videogallery/videoGallerySlice";
import popupSlice from "../features/popup/popupSlice";
import bookingreferenceSlice from "../features/bookingreference/bookingreferenceSlice";
import passwordSlice from "../features/ChangePassword/changePasswordSlice";
import citySlice from "../features/city/citySlice";
import stateSlice from "../features/state/stateSlice";
import countrySlice from "../features/country/countrySlice";
import leadsourceSlice from "../features/leadsource/leadsourceSlice";
import leadStageSlice from "../features/leadstage/leadStageSlice";
import contactSlice from "../features/contact/contactSlice";
import leadSlice from "../features/lead/leadSlice";
import bulkWhatsappSlice from "../features/bulkWhatsapp/bulkWhatsappSlice";
import dashboardSlice from "../features/dashboard/dashboardSlice";
import emailTemplateSlice from "../features/emailTemplate/emailTemplateSlice";
import bulkEmailSlice from "../features/bulkEmail/bulkEmailSlice";
import bookingSlice from "../features/booking/bookingSlice";
import b2bDocumentSlice from "../features/b2bdocument/b2bDocumentSlice";
import b2bInquirySlice from "../features/b2binquiry/b2bInquirySlice";

const store = configureStore({
  reducer: {
    dashboard: dashboardSlice,
    password: passwordSlice,
    bookingReference: bookingreferenceSlice,
    dialog: dialogSlice,
    drawer: drawerSlice,
    user: userSlice,
    menu: menuSlice,
    userType: userTypeSlice,
    inquiry: inquirySlice,
    cms: cmsSlice,
    banner: bannerSlice,
    faq: faqSlice,
    blog: blogSlice,
    testimonial: testimonialSlice,
    seotag: seotagSlice,
    rights: rightsSlice,
    login: loginSlice,
    pagination: paginationSlice,
    setting: settingSlice,
    facility: facilitySlice,
    whychoose: whychooseSlice,
    amenities: amenitiesSlice,
    tourtype: tourtypeSlice,
    activity: activitySlice,
    gallery: gallerySlice,
    room: roomSlice,
    signatureMoment: signatureMomentSlice,
    property: propertySlice,
    experience: experienceSlice,
    philosophy: philosophySlice,
    weddingVenue: weddingVenueSlice,
    ideal: idealSlice,
    attractions: attractionsSlice,
    newsletter: newsletterSlice,
    package: packageSlice,
    position: positionSlice,
    jobapplication: jobapplicationSlice,
    videoGallery: videoGallerySlice,
    popup: popupSlice,
    city: citySlice,
    state: stateSlice,
    country: countrySlice,
    leadsource: leadsourceSlice,
    leadStage: leadStageSlice,
    contact: contactSlice,
    lead: leadSlice,
    bulkWhatsapp: bulkWhatsappSlice,
    emailTemplate: emailTemplateSlice,
    bulkEmail: bulkEmailSlice,
    booking: bookingSlice,
    b2bDocument: b2bDocumentSlice,
    b2bInquiry: b2bInquirySlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
